<script>
/**
 * @overview 首页头部
 *
 * @author huojinzhao
 */

import { mapState } from "vuex";
import { $http, $token } from "@/utils";

export default {
  name: "HomeHeader",

  computed: {
    ...mapState([
      "user",
    ]),
  },

  methods: {
    logoutConfirm() {
      this.$alert(
        "是否确定退出登录？",
        {
          showCancelButton: true,
          type: "warning",
        },
      )
        .then(this.logout);
    },

    logout() {
      $http.post("/user/logout", {})
        .then(() => {
          $token.remove();

          window.location.href = "/login";
        });
    },
  },
};
</script>

<template>
  <header class="home-header">
    <span class="home-header__title">
      imkid课件管理平台
    </span>
    <span class="home-header__user">
      <i class="iconfont icon-user" />
      {{ user.realname }}
    </span>
    <el-button
      icon="iconfont icon-export"
      type="text"
      @click="logoutConfirm"
    >
      退出登陆
    </el-button>
  </header>
</template>

<style lang="postcss">
.home-header {
  display: flex;
  align-items: center;
  padding: 0 2em;
  height: 80px;
  box-shadow: 0 0 3px 3px var(--color-shadow);
  z-index: 0;
}

.home-header__title {
  font-size: 30px;
}

.home-header__user {
  margin-left: auto;
  margin-right: 2em;
}
</style>
